<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    located: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
              rotate: 40,
              showMinLabel: true,
            },
          axisTick: {
              show: true,
              alignWithLabel: true,
            },
          showGrid: false,
        },
        yAxis: {
          splitLine: {
            show: false
          },
          type: "value",
          axisTick:{
            show: false,
          },
          axisLabel: {
              show: false,
            },
        },
        series: [
        {
            name: "Variáveis",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            itemStyle:{
              color: function(item){
                return parseInt(item.value) === 100 ? "#8bc34a" : "#d4716e";
              }
            },
            label: {
              normal: {
                position: "top",
                distance: 15,
                show: true,
                color: "black",
                formatter: (item) => item.value + "%",
              },
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    options() {
        if (!this.data.variables_not_hot) {return this.delChart();}
        else if (!this.data.variables_hot) {return this.delChart();} 
      
      return this.renderChart();
    },
  },
  methods: {
    renderChart() { 

      let options = { ...this.defaultOptions };
      options.series[0].data = [];
      options.xAxis.data = [];

      if (!this.located){
        Object.entries(
          this.data.variables_not_hot
        ).forEach(([index, item]) => {
          options.series[0].data.push((item / this.data.not_located_approachable * 100).toFixed());
  
          options.xAxis.data.push(index);
        });
      }
      else {
        Object.entries(
          this.data.variables_hot
        ).forEach(([index, item]) => {
          options.series[0].data.push((item / this.data.located_approachable * 100).toFixed());
          options.xAxis.data.push(index);
        });
      }

      return options;
    },

    delChart(){
      let options = { ...this.defaultOptions };
      options.series[0].data = [];
      options.xAxis.data = [];

      return options;
    }

  },
};
</script>

<style></style>
